export const shouldUseMockEmailAdministration = (env: NodeJS.ProcessEnv = process.env) =>
  env.NODE_ENV === 'development' && env.REACT_APP_USE_MOCK_EMAIL_ADMINISTRATION === 'true'

export const hasEmailAdministrationMockConfigurationError = (env: NodeJS.ProcessEnv = process.env) =>
  shouldUseMockEmailAdministration(env) &&
  (env.REACT_APP_MOCK_AUTH !== 'true' ||
    env.REACT_APP_API_URL !== '/__email-administration-mock-api' ||
    env.REACT_APP_USE_MOCK_TIMESHEET !== 'false' ||
    env.REACT_APP_FEATURE_UNMAPPED_TIME !== 'false' ||
    env.REACT_APP_ENABLE_USER_AVATAR === 'true' ||
    [
      env.REACT_APP_USE_MOCK_INTEGRATION_SYNC_ADMIN,
      env.REACT_APP_USE_MOCK_ADMIN_CONTEXT,
      env.REACT_APP_USE_MOCK_ADMIN_RECALL,
      env.REACT_APP_USE_MOCK_ADMIN_DELEGATIONS,
      env.REACT_APP_USE_MOCK_PERIOD_MANAGEMENT,
      env.REACT_APP_USE_MOCK_APPROVALS,
      env.REACT_APP_USE_MOCK_APPROVALS_ACCESS,
      env.REACT_APP_USE_MOCK_DELEGATIONS,
      env.REACT_APP_USE_MOCK_DELEGATE_RUNTIME,
      env.REACT_APP_USE_MOCK_UNMAPPED_TIME,
      env.REACT_APP_USE_MOCK_CHR_SEARCH,
      env.REACT_APP_USE_MOCK_ITSM_AUTOFILL,
      env.REACT_APP_USE_MOCK_PROJECT_PLAN,
      env.REACT_APP_USE_MOCK_PROJECT_TYPES,
    ].includes('true'))
